import React, { useState, useContext, useEffect } from "react";
import {
  Typography,
  Stack,
  TextField,
  Button,
  InputAdornment,
  Avatar,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as Yup from "yup";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useQuery, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
//Srcs
import "./login.scss";
import { AuthContext } from "../Context/AuthContext";
import loginImage from "../Assets/Go-Global-School.jpg";
import CircularProgress from "@mui/material/CircularProgress";
import { USER_LOGIN } from "../Schema/User";

export default function Login() {
  const navigate = useNavigate();

  const { setAlert } = useContext(AuthContext);
  const [iconReload, setIconReload] = useState(false);

  // hide password hook
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [login] = useMutation(USER_LOGIN, {
    onCompleted: ({ login }) => {
      console.log('login', login)
      if (login?.status === true) {
        setAlert(true, "success", login?.message);
        localStorage.setItem("token", login?.token);
        localStorage.setItem("userLogin", JSON.stringify(login?.user));
        setTimeout(() => {
          navigate("/");
          setIconReload(false);
        }, 1600);
      } else {
        setIconReload(false);
        setAlert(true, "error", login?.message);
      }
    },
    onError: (err) => {
      setIconReload(false);
      setAlert(true, "error", err?.message);
    },
  });

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email().required("Required"),
    password: Yup.string()
      .required("Required")
      .min(8, "Password must be 8 characters!"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      // console.log("values::", values);
      setIconReload(true);
      login({
        variables: {
          ...values,
        },
      });
    },
  });

  const { errors, touched, handleSubmit, getFieldProps } = formik;

  // useEffect(() => {
  //   if (data?.getUserLogin?.status && iconReload === true) {
  //     setAlert(true, "success", "Login success!");
  //     window.location.reload("/programme");
  //   }

  //   if (data?.getUserLogin?.status === false && iconReload === true) {
  //     setAlert(true, "error", "Login not success!");
  //     window.localStorage.removeItem("token");
  //     window.location.reload();
  //   }
  // }, [iconReload, data?.getUserLogin?.status]);

  return (
    <Stack
      direction="column"
      justifyContent="center"
      className="login-container"
    >
      <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack direction="column" className="box-container" spacing={3}>
              <Stack direction="column" spacing={1}>
                <Stack direction="row" justifyContent="center">
                  <Avatar
                    sx={{ width: 170, height: 170 }}
                    variant="square"
                    alt="logo"
                    src={loginImage}
                  />
                </Stack>
                <Typography
                  variant="body2"
                  align="center"
                  className="login-subtitle"
                >
                  សូមស្វា​គម​ន៏!!
                </Typography>
                <Typography className="login-subtitle1">
                  កម្មវិធីគ្រប់គ្រងសារពើភ័ណ្ឌ
                </Typography>
              </Stack>

              <Stack
                direction="column"
                justifyContent="center"
                width="100%"
                className="box-login"
                spacing={2}
              >
                <Stack direction="column">
                  <Stack direction="row">
                    <Typography className="label-login">អ៊ីម៉ែល</Typography>
                    <Typography
                      className="label-login"
                      style={{ color: "red" }}
                    >
                      *
                    </Typography>
                  </Stack>
                  <TextField
                    fullWidth
                    size="small"
                    className="input-login"
                    placeholder="abc@gmail.com"
                    {...getFieldProps("email")}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Stack>
                <Stack direction="column" spacing={0.5}>
                  <Stack direction="row">
                    <Typography className="label-login">
                      ពាក្យសម្ងាត់
                    </Typography>
                    <Typography
                      className="label-login"
                      style={{ color: "red" }}
                    >
                      *
                    </Typography>
                  </Stack>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="ពាក្យសម្ងាត់"
                    className="input-login"
                    type={show ? "text" : "password"}
                    {...getFieldProps("password")}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start" onClick={handleClick}>
                          {show ? (
                            <VisibilityIcon className="viewpw-icon" />
                          ) : (
                            <VisibilityOffIcon className="viewpw-icon" />
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* <Stack direction="row-reverse">
                    <Link to={"/forgot-password"} className="forgot-password">
                      ភ្លេច​លេខសំងាត់?
                    </Link>
                  </Stack> */}
                </Stack>
              </Stack>
              <Stack direction="column">
                <Button
                  className="btn-sign-in"
                  type="submit"
                  endIcon={
                    iconReload ? (
                      <CircularProgress sx={{ color: "#fff" }} size="20px" />
                    ) : null
                  }
                >
                  ចូល
                </Button>
              </Stack>
              <Stack direction="row" spacing={1} justifyContent="center">
                <Typography className="footer-copy-right-left">
                  អភិវឌ្ឍដោយ៖
                </Typography>
                <Typography className="footer-copy-right">
                  Go Global IT
                </Typography>
              </Stack>
            </Stack>
          </Form>
        </FormikProvider>
      </Stack>
    </Stack>
  );
}
